module.exports = __webpack_public_path__ + "static/media/lexus-star.d6ff4bf9.svg";